import {
  exchangeAgentGuidanceIdFormat,
  productFamilyIdFormat,
} from "@redotech/redo-ids/ids";
import { GuidanceSourceType } from "@redotech/redo-model/exchange-agent-guidance/guidance-source-type";
import * as z from "zod";

const guidanceSourceSchema = z.discriminatedUnion("type", [
  z.object({
    type: z.literal(GuidanceSourceType.PRODUCTS),
    productIds: z.array(productFamilyIdFormat.schema),
  }),
  z.object({
    type: z.literal(GuidanceSourceType.SHOPIFY_COLLECTION),
    shopifyCollectionIds: z.array(z.string()),
  }),
]);

export const createExchangeAgentGuidance = {
  name: "createExchangeAgentGuidance" as const,
  input: z.object({
    name: z.string().min(1),
    /** @deprecated use source instead */
    returnProductIds: z.array(productFamilyIdFormat.schema),
    source: guidanceSourceSchema.optional(),
    recommendations: z.array(
      z.object({
        context: z.string(),
        /** @deprecated use source instead */
        productIds: z.array(productFamilyIdFormat.schema),
        source: guidanceSourceSchema.optional(),
      }),
    ),
  }),
  output: z.object({ id: exchangeAgentGuidanceIdFormat.schema }),
};
